/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum MessageType {
    Request,
    Response
}
